// Local storage
export const STORAGE_JOBS_NAMESPACE = 'XING::Jobs';
export const LO_APPLICATION_SUBMITTED_STORAGE_PREFIX = 'application-submitted';
export const JOBS_REPORTED_JOBS = `${STORAGE_JOBS_NAMESPACE}.reported.jobs`;
export const JOB_AI_SUMMARY_FEEDBACK = `${STORAGE_JOBS_NAMESPACE}.job-ai-summary-feedback`;
export const EXTERNAL_APPLY_FLOW_LOCALSTORAGE_KEY = `${STORAGE_JOBS_NAMESPACE}.external-application-flow`;

// Recommendations
export const RECOMMENDATIONS_COUNT = 50;

// Search
export const SEARCH_PAGE_SIZE = 20;
export const DEFAULT_RADIUS = 0;
export const RADIUS_OPTIONS = [0, 10, 20, 50, 70, 100, 200];
export const DEFAULT_SORT = 'relevance';
export const MIN_SALARY = 0;
export const MAX_SALARY = 200_000;
export const AI_EARN_MORE_MIN_SALARY = 30_000;
export const AI_EARN_MORE_MAX_SALARY = 200_000;
export const AI_EARN_MORE_SALARY_STEP = 5_000;
export const SALARY_STEP = 1000;
export const SEARCH_STATE_FILTER_PARAMS = {
  // Filters
  careerLevel: 'careerLevel',
  city: 'city',
  company: 'company',
  country: 'country',
  discipline: 'discipline',
  employmentType: 'employmentType',
  industry: 'industry',
  remoteOption: 'remoteOption',
  salary: 'salary',
  // Other query params
  page: 'page',
  sort: 'sort',
  sincePeriod: 'sincePeriod',
  since: 'since',
  // Hidden
  paidOnly: 'p',
} as const;
export const SEARCH_STATE_PARAMS = {
  // Inputs
  keywords: 'keywords',
  location: 'location',
  radius: 'radius',
  cityId: 'cityId',
  ...SEARCH_STATE_FILTER_PARAMS,
} as const;
export const SEARCH_STATE_DISABLED_SUFFIX = '_off';
export const SEARCH_STATE_DISABLED_FILTER_PARAMS = {
  careerLevel: `${SEARCH_STATE_PARAMS.careerLevel}${SEARCH_STATE_DISABLED_SUFFIX}`,
  employmentType: `${SEARCH_STATE_PARAMS.employmentType}${SEARCH_STATE_DISABLED_SUFFIX}`,
  remoteOption: `${SEARCH_STATE_PARAMS.remoteOption}${SEARCH_STATE_DISABLED_SUFFIX}`,
  salary: `${SEARCH_STATE_PARAMS.salary}${SEARCH_STATE_DISABLED_SUFFIX}`,
  location: `${SEARCH_STATE_PARAMS.location}${SEARCH_STATE_DISABLED_SUFFIX}`,
} as const;
export const SEARCH_QUERY_ID_PARAM = 'id';
export const SEARCH_STATE_SEPARATOR = '*';
export const SMALL_SCREEN_BOTTOM_SHEET_PARAM = 'filter_view';
export const SEARCH_COUNT_LOCAL_STORAGE = 'SEARCH_QUERY_COUNT';
export const AI_SEARCH_ERROR_BANNER = 'ai_error';
export const AI_SEARCH_ERROR_TYPE = { FABI: 'fabi' } as const;
export const AI_SEARCH_FEEDBACK_SURVEY_URL =
  'https://survey2.quantilope.com/MCiuszw4PWuKrKXZ9/oaYSsNX9N47K8Ycz4';
export const AI_SEARCH_FEEDBACK_SURVEY_URL_LO_SWIMP =
  'https://survey2.quantilope.com/3AvkKiq6WnDXemq3r/L5SC9kRaNtNw3pNLL';
export const AI_SEARCH_INIT_PROMPT_PARAM = 'i';
export const AI_FABI_TRACKING_TOKEN_PARAM = 'tt';

// Search alerts
export const MAX_ALERT_COUNT = 40;
export const CREATE_SEARCH_ALERT_PARAM = 'create_search_alert';
export const SEARCH_ALERTS_MODAL_PARAM = 'sa_modal';
export const REFERRER_ALERT_ID_PARAM = 'referrer_alert_id';
export const SEARCH_ALERTS_MODAL_TYPES = {
  REPEAT: 'repeat',
  CREATE: 'create',
  EMPTY_STATE: 'empty_state',
  JOB_DETAILS: 'job_details',
} as const;
export const SEARCH_ALERTS_ERROR_BANNER = 'sa_error';
export const SEARCH_ALERTS_ERROR_TYPE = {
  CREATE: 'create',
  DELETE: 'delete',
  DUPLICATED: 'duplicated',
} as const;
export const SEARCH_ALERTS_EMAIL_BANNER_STATE = 'email_banner';

// Recent searches
export const SEARCH_BOX_MAX_RECENT_SEARCHES = 5;

// Job details
export const SUPPORTED_SUMMARY_LANGUAGES = ['de', 'en'];
export const JDP_SA_DEFAULT_QUERY = 'jdpSearchAlertDefaultQuery';

// Generic
export const ORIGIN_PARAM = 'origin';
export const ORIGIN_PARAM_VALUES = {
  searchAlertsFindJobs: 'search_alerts_find_jobs',
  searchAlerts: 'search_alerts',
};

// Layout
export const TOP_BAR_HEIGHT_DESKTOP = 84;
export const TOP_BAR_HEIGHT_MOBILE = 54;
export const BOTTOM_BAR_HEIGHT = 60;

// Brewery
export const FLAG = {
  AMBASSADOR: 'ambassador',
  BASIC: 'basic',
  PREMIUM: 'premium',
  EXECUTIVE: 'basic',
  INSIDER: 'insider',
  MODERATOR: 'moderator',
  PRO_COACH: 'proCoach',
  PRO_TRAINER: 'proTrainer',
} as const;
export const GENDER = {
  MALE: 'male-user',
  FEMALE: 'female-user',
  NONE: 'neutral-user',
  OTHER: 'neutral-user',
} as const;

//Cookie Consent Usercentrics ids
export const YOUTUBE = 'BJz7qNsdj-7';
export const VIMEO = 'HyEX5Nidi-m';
export const PERSONALWERK = 'tm9CnFna9HdBmV';
